/**
 * Component: RagSourceViewer
 * Displays RAG sources in a modal
 */

import React, { useEffect } from 'react';
import { useTranslation } from '../context/TranslationContext';

export default function RagSourceViewer({ sources, onClose }) {
  const { t, loadPageTranslations } = useTranslation();

  useEffect(() => {
    loadPageTranslations('CHATBOT');
  }, [loadPageTranslations]);

  if (!sources || sources.length === 0) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-96 overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
          <h2 className="text-lg font-bold text-gray-900">
            {t('CHATBOT', 'RAG_SOURCES', 'Referenced Articles')}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 font-bold text-xl"
          >
            ✕
          </button>
        </div>

        <div className="p-6 space-y-4">
          {sources.map((source, index) => (
            <div
              key={`${source.id}_${source.chunkOrder}`}
              className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
            >
              <div className="flex items-start gap-3">
                <div className="flex items-center justify-center w-6 h-6 bg-blue-100 text-blue-600 rounded-full font-semibold text-sm flex-shrink-0">
                  {index + 1}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-gray-900 break-words">
                    {source.title}
                  </h3>
                  <p className="text-xs text-gray-600 mt-1 break-all">
                    <span className="text-gray-500">URL: </span>
                    <a
                      href={source.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-800 underline"
                    >
                      {source.url}
                    </a>
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    {t('CHATBOT', 'SIMILARITY', 'Similarity')}:{' '}
                    {(source.similarity * 100).toFixed(1)}%
                  </p>
                  <a
                    href={source.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-blue-600 hover:text-blue-800 mt-2 inline-flex items-center gap-1"
                  >
                    {t('CHATBOT', 'VIEW_ARTICLE', 'View Article')} →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
